import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import { AlertTitle, Button, Link } from "@mui/material";

import { formatLocalDateTime } from "utils/date";
import { DISCONNECT_HISTORY_VISIBLE_COUNT } from "static/constants";
import useDisconnectHistory, {
  sortStatusesNewestFirst,
} from "components/pages/transmissions/modal/patient/tabs/subscription/disconnectHistory/useDisconnectHistory";

const EpisodeStatuses = ({ statuses }) => {
  const [expanded, setExpanded] = useState(false);
  const hiddenCount = Math.max(
    statuses.length - DISCONNECT_HISTORY_VISIBLE_COUNT,
    0
  );

  const ordered = sortStatusesNewestFirst(statuses);
  const shown =
    expanded || hiddenCount === 0
      ? ordered
      : ordered.slice(0, DISCONNECT_HISTORY_VISIBLE_COUNT);

  return (
    <div style={{ opacity: 0.8 }}>
      {statuses.length > 1 ? "Reported as " : "Reason: "}
      {shown.map((entry, entryIndex) => (
        <React.Fragment key={`${entry?.recorded_at}-${entryIndex}`}>
          {entryIndex > 0 && " ← "}
          {entry?.status || "no reason given"} (
          {formatLocalDateTime(entry?.recorded_at)})
        </React.Fragment>
      ))}
      .
      {hiddenCount > 0 && (
        <Link
          component="button"
          type="button"
          underline="none"
          color="secondary"
          sx={{
            ml: 1,
            p: 0,
            font: "inherit",
            lineHeight: "inherit",
            verticalAlign: "baseline",
          }}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "See less" : `See ${hiddenCount} earlier`}
        </Link>
      )}
    </div>
  );
};

const DisconnectHistory = () => {
  const theme = useTheme();
  const { resolved, showAll, hasMore, visibleResolved, setShowAll } =
    useDisconnectHistory();

  if (resolved.length === 0) {
    return null;
  }

  return (
    <>
      <AlertTitle style={{ fontWeight: 700, color: theme.palette.info.main }}>
        Resolved Disconnects:
      </AlertTitle>

      <div className="mb-3">
        {visibleResolved.map((episode, index) => (
          <div
            key={`${episode.disconnectedAt}-${index}`}
            style={{ marginBottom: "6px" }}
          >
            <div>
              Disconnected on{" "}
              <strong>{formatLocalDateTime(episode.disconnectedAt)}</strong>,
              reconnected{" "}
              <strong>{formatLocalDateTime(episode.reconnectedAt)}</strong>.
            </div>

            <EpisodeStatuses statuses={episode.statuses} />
          </div>
        ))}

        {hasMore && (
          <Button
            variant="text"
            color="secondary"
            style={{ padding: 0, marginTop: "4px" }}
            onClick={() => setShowAll(!showAll)}
          >
            {showAll
              ? "See less"
              : `See more (${resolved.length - visibleResolved.length})`}
          </Button>
        )}
      </div>
    </>
  );
};

export default DisconnectHistory;
